export const TREE_EVENTS = {
  toggleExpanded: 'toggleExpanded',
  activate: 'activate',
  deactivate: 'deactivate',
  nodeActivate: 'nodeActivate',
  nodeDeactivate: 'nodeDeactivate',
  select: 'select',
  deselect: 'deselect',
  focus: 'focus',
  blur: 'blur',
  initialized: 'initialized',
  updateData: 'updateData',
  moveNode: 'moveNode',
  copyNode: 'copyNode',
  event: 'event',
  loadNodeChildren: 'loadNodeChildren',
  changeFilter: 'changeFilter',
  stateChange: 'stateChange'
};
